import { type JSX, type ReactNode } from 'react';

import { Dialog, useDialog } from '@cx-modules/ui';

import { useOddsGridContext } from '../../context/OddsGridContext';
import { useBookmakerData } from '../../hooks/useBookmakerData';
import { useSelector } from '../../providers/StoreProvider';
import { oddsShownType } from '../../types';
import { type Offer } from '../../types';
import { BookmakerClickOut } from '../BookmakerClickOut';
import { OffersDialog } from '../OffersDialog';

import { OfferAmount, OffersMobileContainer, SeeOffersBtn, SignupOfferWrapper } from './style';

export const OffersGridCellMobile = ({
  bookieCode,
  children,
  signupOffers = [],
}: {
  bookieCode: string;
  children: ReactNode;
  signupOffers: Offer[];
}): JSX.Element => {
  const repub = useSelector(state => state.repub);
  const { oddsShown } = useOddsGridContext();
  const { bookmaker } = useBookmakerData(bookieCode);

  const hasSignupOffers = signupOffers.length > 0;
  const hasOffers = hasSignupOffers;
  const isNonClickable = oddsShown === oddsShownType.OC_NON_CLICKABLE;

  const { code, name } = bookmaker;

  const { dialogContext, hide } = useDialog('offers-btn');

  const signUp = hasSignupOffers && (
    <SignupOfferWrapper>
      <OfferAmount data-testid="signup-offer">{signupOffers[0].amount}</OfferAmount>
    </SignupOfferWrapper>
  );

  const offersBtn = hasOffers && (
    <SeeOffersBtn {...dialogContext}>
      <BookmakerClickOut
        bookmakerCode={code}
        eventLabel="grid_bookie_logo_top"
        isNonClickable={isNonClickable}
        repub={repub}
        title={name}
      >
        See Offers
      </BookmakerClickOut>
    </SeeOffersBtn>
  );

  return (
    <>
      <OffersMobileContainer>
        {children}
        {signUp}
        {offersBtn}
      </OffersMobileContainer>
      <Dialog context={dialogContext}>
        <OffersDialog bookieCode={bookieCode} onCloseClicked={hide}></OffersDialog>
      </Dialog>
    </>
  );
};
